import { Image } from '@perxis-auto/ui-kit/lib/components/Gallery';

import { IMedia } from '@/interfaces/grpc.interfaces';
import { ISettings } from '@/interfaces/settings.interfaces';

type OptionsType = {
  media: ISettings['media'];
};

/**
 * Формирует подготовленный объект изображения для бренда в Model Checkbox
 * @param marketingMedia
 * @param options
 * @returns {Image} Картинка для бренда в Model Checkbox
 */
const getBrandImage = (marketingMedia: IMedia, options: OptionsType): Image => {
  const { media } = options;

  const title = marketingMedia.name;

  if (!marketingMedia || !marketingMedia.file) {
    return {
      title,
    };
  }

  const original = `${media.apiRoot}/${marketingMedia.file.id}`;

  return {
    original,
    title,
  };
};

export default getBrandImage;
